import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../../types/types';
import { onClick } from './events/onClick';
import { IChatsPanelButtonHOCProps } from './types';
import { ChatsPanelButton } from '../../components/ChatsPanelButton/ChatsPanelButton';
import { IChatsPanelButtonEvents, IChatsPanelButtonFields } from '../../components/ChatsPanelButton/types';
import { isShowChat } from 'app/store/model/authUser/selectors/isShowChat';
import { getBoard } from 'app/store/model/selectors/getBoardById';
import { getChatDashboardSettingsByBoardId } from 'app/store/model/chatDashboardSettings/selectors/getChatDashboardSettingsByBoardId';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IChatsPanelButtonHOCProps
): IChatsPanelButtonFields => {
    return {
        boardId,
        tooltip: null,
        isShow: isShowChat(state) && getBoard(state, boardId).shared,
        indicatorBoolean: getChatDashboardSettingsByBoardId(state, boardId).enabled
    }
};

const mapDispatchToProps = (
    dispatch: any,
    {onClick: ownOnClick}: IChatsPanelButtonHOCProps
): IChatsPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const ChatsPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChatsPanelButton);

ChatsPanelButtonHOC.displayName = 'ChatsPanelButtonHOC';
